export default __webpack_public_path__ + "static/media/virtual_warehouse.b2288a4a.svg";